module.exports = __webpack_public_path__ + "static/media/insta-rnt.e0c61e6d.png";